<template>
  <v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>  
    <v-card
      width="100%"
      style="border-radius: 10px"
      class="pa-3"
      v-show="!overlay"
    >
      <v-card-title class="title font-weight-light">
        User Management
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-card-text>
        <div class="d-flex justify-content-between">
          <div
            class="mr-4"
            style="max-width: 350px"
          >
            <v-combobox
              dense
              hide-details
              :items="dataCompany"
              item-text="tradingname"
              item-value="clientid"
              label="Filter Company"
              outlined
              v-model="selectedCompany"
              v-if="isSuperAdmin"
            />
          </div>
          <v-spacer />
          <div class="d-flex">
            <v-btn
              color="#00ACDC"
              dark
              class="mb-2 ml-auto"
              v-if="isAdmin || isSuperAdmin"
              @click="dialog = true"
            >
              CREATE NEW USER
            </v-btn>

            <div
              class="d-flex"
              v-if="isIntimap || isWSP"
            >
              <v-btn
                color="primary"
                dark
                class="mb-2 ml-2"
                v-if="isAdmin || isSuperAdmin"
                @click="openBulkEditDialog"
              >
                Bulk Edit Timezone
              </v-btn>
            </div>
            <v-btn
              class="mb-2 ml-2"
              v-if="showButtonLink"
              @click="dialog2 = true"
            >
              INVITE USER
            </v-btn>
            <v-btn
              color="#00ACDC"
              class="mb-2 ml-2"
              v-if="isAdmin || isSuperAdmin"
              :loading="loadingUpdate"
              :disabled="loadingUpdate"
              @click="generateReport"
              outlined
            >
              Generate Report
            </v-btn>
          </div>
        </div>
        <v-data-table
          :headers="headers"
          :items="dataApi"
          sort-by="username"
          class="font-weight-light pa-5"
          :loading="loadingUser"
          :footer-props="footerProps"
          @update:options="updatePaging"
          :server-items-length="userTotal"
          :options.sync="paginationOptions"
        >
          <template #[`item.id`]="{ item }">
            {{ (paginationOptions.page - 1) * paginationOptions.itemsPerPage + (dataApi.indexOf(item) + 1) }}
          </template>
          <template #[`item.metadata.photo`]="{ item }">
            <v-tooltip
              bottom
              v-if="item.metadata.photo"
            >
              <template #activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="blue"
                  @click="showPhoto(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>
                    mdi-eye
                  </v-icon>
                </v-btn>
              </template>
              <span>Show photo</span>
            </v-tooltip>
          </template>
          <template #[`item.type`]="{ item }">
            {{ typeText(item) }}
          </template>
          <template #[`item.asset_group`]="{ item }">
            <v-chip
              v-for="(group, index) in assetGroupText(item)"
              :key="index"
              small
              class="mx-1 my-1"
              color="primary"
              text-color="white"
            >
              {{ group }}
            </v-chip>
          </template>
          <template #[`item.action`]="{ item }">
            <v-row dense>
              <v-col
                cols="12"
                sm="6"
              >
                <v-tooltip bottom>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="green"
                      @click="editItem(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-tooltip bottom>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="red"
                      @click="deleteItem(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
          <template #[`item.metadata.driver_license.expiry_date`]="{ item }">
            {{ setHumanDate(item) }}
          </template>
          <template #[`item.metadata.driver_license`]="{ item }">
            <v-chip
              small
              :color="setColor(item)"
              class="font-weight-bold"
            >
              {{ setStatus(item) }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialog"
      max-width="900"
      persistent
      scrollable
    >
      <v-card outlined>
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="#00ACDC"
                class="mx-2"
              >
                mdi-account-plus
              </v-icon>{{ formTitle }}
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-alert
          v-model="isError"
          type="error"
          dismissible
          class="my-0"
        >
          Username or Email already used
        </v-alert>
        <v-alert
          v-model="emailCheck"
          type="error"
          dismissible
          class="my-0"
        >
          Email already used
        </v-alert>
        <v-alert
          v-model="existUECheck"
          type="error"
          dismissible
          class="my-0"
        >
          Username and Email already exist!
        </v-alert>
        <v-skeleton-loader
          v-if="loadingAssetGroup"
          type="list-item-two-line"
        />
        <v-card-text
          class="my-0"
          v-else
        >
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="First Name"
                    v-model="editedItem.first_name"
                    required
                    :rules="[(v) => !!v || 'First name is required']"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Last Name"
                    v-model="editedItem.last_name"
                  />
                </v-col>
                <v-col
                  class="pb-0"
                  cols="12"
                  sm="12"
                  v-if="isSSO"
                >
                  <v-checkbox
                    class="my-0"
                    dense
                    label="Log In Using SSO"
                    color="info"
                    v-model="editedItem.metadata.use_sso"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  v-if="editedIndex === -1 && !editedItem.metadata.use_sso"
                >
                  <v-text-field
                    outlined
                    color="success"
                    hide-details
                    label="Username"
                    v-model="editedItem.username"
                    :rules="usernameRules"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  :sm="editedItem.metadata.use_sso ? '12' : '6'"
                  v-if="editedIndex !== -1"
                >
                  <v-text-field
                    outlined
                    color="success"
                    hide-details
                    label="Username"
                    v-model="editedItem.username"
                    :rules="usernameRules"
                    required
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  v-if="editedIndex === -1 && !editedItem.metadata.use_sso"
                >
                  <v-text-field
                    outlined
                    color="success"
                    :type="showPassword ? 'text' : 'password'"
                    label="Password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    v-model="editedItem.password"
                    :rules="passwordRules"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="isVA"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Phone"
                    v-model="editedItem.phone"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="$store.state.type == 3"
                >
                  <v-select
                    hide-details
                    :items="dataCompany"
                    :item-text="(company) => `${company.tradingname}`"
                    :item-value="(company) => `${company.clientid}`"
                    label="Company"
                    outlined
                    v-model="editedItem.clientid"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-select
                    hide-details
                    :items="type"
                    label="Type"
                    outlined
                    v-model="editedItem.type"
                    :rules="typeRules"
                    required
                  >
                    <template #selection="{ item }">
                      {{ typeUser(item) }}
                    </template>
                    <template #item="{ item }">
                      {{ typeUser(item) }}
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-combobox
                    hide-details
                    :items="dataTimezone"
                    item-text="value"
                    label="Timezone"
                    outlined
                    v-model="editedItem.timezone"
                    :rules="timezoneRules"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="rfidRequired"
                >
                  <v-select
                    hide-details
                    :items="rfid_types"
                    :item-text="(rfid_type) => `${rfid_type.name}`"
                    :item-value="(rfid_type) => `${rfid_type.name}`"
                    label="RFID Type"
                    outlined
                    v-model="editedItem.metadata.rfid_type"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="editedItem.metadata.rfid_type && rfidRequired"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Key Cabinet RFID"
                    v-model="editedItem.metadata.key_cabinet_rfid"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-divider />
                </v-col>
                <v-col
                  sm="12"
                  class="font-weight-medium"
                >
                  Driver Licence Details
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Issuing state"
                    v-model="editedItem.metadata.driver_license.issuing_state"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Licence type"
                    v-model="editedItem.metadata.driver_license.license_type"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Conditions"
                    v-model="editedItem.metadata.driver_license.conditions"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    color="success"
                    label="Licence no"
                    v-model="editedItem.metadata.driver_license.license_no"
                  />
                </v-col>
                <v-col sm="12">
                  <v-menu
                    v-model="isOpenDate"
                    :close-on-content-click="false"
                    max-width="290px"
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        :value="editedItem.metadata.driver_license.expiry_date"
                        outlined
                        clearable
                        label="Expiry date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="date = null"
                        :rules="expiryDateRules"
                        hide-details
                      />
                    </template>
                    <v-date-picker
                      v-model="editedItem.metadata.driver_license.expiry_date"
                      @change="isOpenDate = false"
                    />
                  </v-menu>
                </v-col>
                <v-col
                  sm="12"
                  v-if="editedIndex === -1 && !isWollongong"
                >
                  <v-file-input
                    v-model="editedItem.metadata.driver_license.upload_photo"
                    label="Upload your licence photo"
                    outlined
                    prepend-icon=""
                    hide-details
                    type="file"
                  />
                  <div
                    class="v-messages theme--light error--text mt-1"
                    v-if="uploadPhotoRequired"
                  >
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message">
                        Please Complete Field
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col
                  sm="12"
                  class="font-weight-medium"
                  v-if="editedIndex !== -1 && !isWollongong"
                >
                  Licence photo
                  <v-btn
                    small
                    outlined
                    color="primary"
                    @click="showPhotoEdit()"
                  >
                    Show
                  </v-btn>
                </v-col>
                <v-col
                  sm="12"
                  v-if="editedIndex !== -1 && !isWollongong"
                >
                  <v-file-input
                    v-model="changePhoto"
                    label="Change your licence photo"
                    outlined
                    prepend-icon=""
                    hide-details
                    type="file"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="isEditOrCreateUser"
                >
                  <v-divider />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="editedIndex === -1 && isEditOrCreateUser"
                >
                  <v-combobox
                    v-model="assetGroup"
                    :items="assetGroups"
                    item-text="name"
                    item-value="id"
                    label="Asset Group"
                    multiple
                    outlined
                    required
                    hide-details
                    :rules="[(v) => v.length ? null : 'Please select at least one group!']"
                  >
                    <template #selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.name }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >
                        (+{{ assetGroup.length - 1 }} others)
                      </span>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="editedIndex !== -1 && isEditOrCreateUser"
                >
                  <v-combobox
                    v-model="assetGroupsEdit"
                    :items="assetGroups"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400' }"
                    label="Asset Group"
                    outlined
                    persistent-hint
                    multiple
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="editedItem.type === '2' || editedItem.type === '4'"
                >
                  <v-checkbox
                    class="my-0"
                    dense
                    :readonly="!isEditOrCreateUser"
                    label="Allowing this user to book for others"
                    color="info"
                    hide-details
                    v-model="editedItem.metadata.as_manager"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-checkbox
                    class="my-0"
                    dense
                    label="Special Group For All States"
                    color="info"
                    :disabled="(!isAdmin && !isSuperAdmin) || editedItem.metadata.is_special_state"
                    v-model="editedItem.metadata.is_special"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-checkbox
                    class="my-0"
                    dense
                    label="Special Group For States"
                    color="info"
                    :disabled="(!isAdmin && !isSuperAdmin) || editedItem.metadata.is_special"
                    v-model="editedItem.metadata.is_special_state"
                    @click="handleClickSpecialState"
                  />
                  <v-autocomplete
                    v-model="editedItem.metadata.special_states"
                    :items="cabinets"
                    :item-text="(item) => `${item.state}`"
                    :item-value="(item) => `${item.id}`"
                    multiple
                    clearable
                    label="Select States"
                    outlined
                    hide-details
                    :disabled="!cabinetLoaded"
                    v-show="editedItem.metadata.is_special_state"
                  >
                    <template #selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.state }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >
                        (+{{ editedItem.metadata.special_states.length - 1 }}
                        others)
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-show="false"
                >
                  <v-divider />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-show="false"
                >
                  <v-autocomplete
                    v-model="editedItem.metadata.user_manage"
                    :items="userDatas"
                    :item-text="(item) => `${item.first_name} ${item.last_name ? item.last_name : ''}`"
                    :item-value="(item) => `${item.id}`"
                    multiple
                    clearable
                    auto-select-first
                    label="Select user wants to manage"
                    outlined
                    required
                    hide-details
                  >
                    <template #selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.first_name }} {{ item.last_name }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >
                        (+{{ editedItem.metadata.user_manage.length - 1 }}
                        others)
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeModal"
            color="error"
          >
            CLOSE
          </v-btn>
          <v-btn
            @click="save"
            type="submit"
            color="success"
            to="/user"
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
          >
            SUBMIT
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deldialog"
      persistent
      max-width="500"
    >
      <v-card
        dark
        color="red"
      >
        <v-card-title>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Are you sure to want to delete
            this user?
          </span>
        </v-card-title>
        <v-card-text> You will delete this user permanently. </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="deldialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            @click="deleteUser()"
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog2"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Invite user</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="10"
              >
                <v-text-field
                  v-model="shareLink"
                  ref="textToCopy"
                  readonly
                >
                  <template #label>
                    Share this link to invite user
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="2"
              >
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  small
                  outlined
                  color="#00ACDC"
                  @click="copyLink"
                >
                  <v-icon dark>
                    mdi-content-copy
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <div class="d-flex align-center my-2">
              <v-divider />
              <span class="mx-3 grey--text subtitle-2">OR</span>
              <v-divider />
            </div>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="inviteEmail"
                  label="Send invitation email directly"
                  placeholder="email@example.com"
                  outlined
                  dense
                  :rules="inviteEmailRules"
                  hide-details="auto"
                />
              </v-col>
              <v-col
                cols="12"
                class="text-right"
              >
                <v-btn
                  :color="inviteEmail ? '#00ACDC' : ''"
                  :dark="!!inviteEmail"
                  :loading="loadingInvite"
                  :disabled="loadingInvite || !inviteEmail"
                  @click="sendInvitationEmail"
                >
                  <v-icon left>
                    mdi-email-send
                  </v-icon>
                  Send Invitation Email
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog3"
      max-width="500px"
    >
      <v-card
        dark
        color="green"
      >
        <v-card-title>
          <span>
            <v-icon>mdi-check-circle</v-icon> Success to copy this link!
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialog3 = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showPhotoDialog"
      max-width="500"
    >
      <v-card>
        <v-img
          :src="photoUrl"
          height="320px"
          class="grey lighten-1"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            text
            @click="showPhotoDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showDefaultPhoto"
      max-width="500"
    >
      <v-card>
        <v-img
          src="no-photo.png"
          aspect-ratio="1"
          class="grey lighten-1"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            text
            @click="showDefaultPhoto = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="bulkEditDialog"
      max-width="800"
    >
      <v-card>
        <v-card-title class="headline">
          <span>Bulk Edit Timezone</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container
            fluid
            class="px-0 py-0"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-select
                  hide-details
                  :items="dataTimezone"
                  item-text="value"
                  label="Select Timezone"
                  outlined
                  v-model="bulkEditTimezone"
                  :rules="timezoneRules"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                class="d-flex align-center pb-0"
              >
                <v-checkbox
                  :input-value="isAllChecked"
                  @change="toggleCheckAll"
                  hide-details
                  color="primary"
                  class="ma-0 pa-0"
                  :label="isAllChecked ? 'Uncheck All Users' : 'Check All Users'"
                  style="margin-top: -8px;"
                >
                  <template #label>
                    {{ isAllChecked ? 'Uncheck All Users' : 'Check All Users' }}
                  </template>
                </v-checkbox>
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-autocomplete
                  v-model="bulkEditUsers"
                  :items="userTimezoneOptions"
                  :item-text="(item) => `${item.first_name} ${item.last_name}`"
                  :item-value="(item) => `${item.id}`"
                  multiple
                  clearable
                  auto-select-first
                  label="Select Users"
                  outlined
                  required
                  hide-details
                >
                  <template #selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.first_name }} {{ item.last_name }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="grey--text caption"
                    >
                      (+{{ bulkEditUsers.length - 1 }} others)
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-end mx-2 py-5">
          <v-btn
            class="text-light"
            @click="bulkEditDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            :loading="loadingBulkEdit"
            :disabled="loadingBulkEdit || !bulkEditUsers.length || !bulkEditTimezone"
            @click="bulkEditUsersTimezone"
          >
            {{ bulkEditButtonText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import api from '../api'
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import BigNumber from "bignumber.js";
import moment from 'moment';

const crypto = require("crypto");
const md5 = (data) =>
  crypto
    .createHash("md5")
    .update(data)
    .digest("hex");

export default {
  data: () => ({
    isError: false,
    emailCheck: false,
    existUECheck: false,
    copyData: "copy asdsadsad",
    dialog: false,
    deldialog: false,
    dialog2: false,
    groupUser_id: "",
    dialog3: false,
    valid: true,
    passwordRules: [
      (v) => !!v || "Password is required",
      (v) => v.length < 6 ? 'Password must contains minumum 6 characters!' : null,
    ],
    usernameRules: [(v) => !!v || "Username is required"],
    typeRules: [(v) => !!v || "Type is required"],
    timezoneRules: [(v) => !!v || "Timezone is required"],
    emailRules: [
      (v) => !!v || "Email is required",
      (value) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(value) || 'Invalid e-mail.'
      },
    ],
    clientRules: [(v) => !!v || "Client id is required"],
    headers: [
      { text: "No  ", value: "id", sortable: false },
      { text: "Username", value: "username" },
      { text: "First Name ", value: "first_name" },
      { text: "Last Name ", value: "last_name" },
      { text: "Email ", value: "email" },
      { text: "Type ", value: "type" },
      { text: "Asset Groups ", value: "asset_group", sortable: false },
      { text: "Issuing State", value: "metadata.driver_license.issuing_state", sortable: false },
      { text: "Licence Type", value: "metadata.driver_license.license_type", sortable: false },
      { text: "Conditions", value: "metadata.driver_license.conditions", sortable: false },
      { text: "Licence No", value: "metadata.driver_license.license_no", sortable: false },
      { text: "Expiry Date", value: "metadata.driver_license.expiry_date", sortable: false },
      { text: "Expiry Status", value: "metadata.driver_license", sortable: false },
      { text: "Photo of Licence", value: "metadata.photo", sortable: false },
      { text: "Actions", value: "action", sortable: false },
    ],
    rfid_types: [
      {
        name: 'RFID Card'
      },
      {
        name: 'RFID Key Ring'
      },
      {
        name: 'RFID Sticker'
      }
    ],
    dataApi: [],
    dataTimezone: [],
    dataCompany: [],
    getBookedDataById: [],
    showPassword: false,
    type: [],
    token: "",
    book_id: "",
    isAdmin: "",
    isSuperAdmin: false,
    editedIndex: -1,
    dataGroups: [],
    dataGroupsUser: [],
    groups: [],
    assetGroupsEdit: [],
    grpAssets: [],
    selectedCompany: [],
    selectedCompanyParam: "",
    editedItem: {
      username: "",
      password: "",
      clientid: "",
      email: "",
      first_name: "",
      last_name: "",
      type: "2",
      phone: "",
      timezone: {
        value: "AUS Eastern Standard Time"
      },
      metadata: {
        vehicle_type: [],
        rfid_type: "",
        key_cabinet_rfid: "",
        key_cabinet_rfid_bin: "",
        user_manage: [],
        as_manager: false,
        is_special: false,
        is_special_state: false,
        special_states: [],
        driver_license: {
          issuing_state: "",
          license_type: "",
          conditions: "",
          license_no: "",
          expiry_date: "",
        },
        upload_photo: "",
        use_sso: false,
      },
    },
    defaultItem: {
      username: "",
      password: "",
      clientid: "",
      email: "",
      first_name: "",
      last_name: "",
      type: "",
      timezone: "",
      phone: "",
      metadata: {
        vehicle_type: [],
        rfid_type: "",
        key_cabinet_rfid: "",
        key_cabinet_rfid_bin: "",
        user_manage: [],
        as_manager: false,
        is_special: false,
        is_special_state: false,
        special_states: [],
        driver_license: {
          issuing_state: "",
          license_type: "",
          conditions: "",
          license_no: "",
          expiry_date: "",
        },
        upload_photo: "",
        use_sso: false,
      },
    },
    shareLink: "",
    inviteEmail: "",
    loadingInvite: false,
    inviteEmailRules: [
      (v) => !v || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid e-mail.',
    ],
    emailAddress: null,
    showPhotoDialog: false,
    photoUrl: "",
    vhcTypes: [],
    vhcTypeId: [],
    userDatas: [],
    loadingAssetGroup: false,
    loadingUpdate: false,
    loader: null,
    searchData: "",
    issuingStateRules: [(v) => !!v || "Issuing state is required"],
    licenseTypeRules: [(v) => !!v || "Licence type is required"],
    conditionsRules: [(v) => !!v || "Conditions is required"],
    licenseNoRules: [(v) => !!v || "Licence no is required"],
    expiryDateRules: [(v) => !!v || "Expiry date is required"],
    assetGroups: [],
    assetGroup: [],
    isOpenDate: false,
    groupParam: [],
    uploadPhotoRequired: false,
    overlay: false,
    successUser: false,
    icreateUser: false,
    iupdateUser: false,
    ideleteUser: false,
    loadingUser: false,
    searchTimeout: null,
    userTotal: 0,
    footerProps: {
      itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
    },
    paginationOptions: {
      sortBy: [],
      sortDesc: [],
      page: 1,
      itemsPerPage: 10
    },
    showDefaultPhoto: false,
    page: "",
    perpage: "",
    isErrorCreateLicense: "",
    isErrorUpdateLicense: "",
    changePhoto: "",
    responseReport: [],
    userTimezoneOptions: [],
    bulkEditUsers: [],
    bulkEditTimezone: null,
    bulkEditDialog: false,
    bulkEditButtonText: "Submit",
    loadingBulkEdit: false,
  }),
  computed: {
    isAllChecked() {
      return this.bulkEditUsers.length === this.userTimezoneOptions.length && this.bulkEditUsers.length > 0;
    },
    cabinetLoaded() {
      return this.$store.getters["getCabinetLoaded"];
    },
    cabinets() {
      return this.$store.getters["getCabinets"];
    },
    companyMetadata() {
      const companyData = this.$store.getters["getCompanyData"];
      return get(companyData, 'metadata', {});
    },
    isSSO() {
      const { azure_client_id, azure_tenant_id } = this.companyMetadata;
      return Boolean(azure_client_id && azure_tenant_id);
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add User" : "Edit User";
    },
    showButtonLink() {
      if (this.isAdmin) {
        if (this.emailAddress === null) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    isEditOrCreateUser() {
      return this.editedItem.type === '2' || this.editedItem.type === '4';
    },
    rfidRequired() {
      let noNeedRFID = get(this.companyMetadata, 'no_need_rfid', false);
      noNeedRFID = this.getValueAsBoolean(noNeedRFID);
      return !noNeedRFID;
    },
    isVA() {
      return this.$store.state.clientid == 'DDE1PXM1E448';
    },
    isWollongong() {
      return this.$store.state.clientid == 'A506MF91OINZ';
    },
    isNedland() {
      return this.$store.state.clientid == 'GJ5790IRPNC0';
    },
    isWSP() {
      return this.$store.state.clientid == 'H1O5G7P0N3JA';
    },
    isIntimap() {
      return this.$store.state.clientid == 'DSSTWWLLIHH7';
    },
  },
  created() {
    this.isAdmin = this.$store.state.type === '1';
    this.isSuperAdmin = this.$store.state.type === '3';
    if (this.$store.state.type == 3) {
      this.type = ["1", "5", "2", "3", "4"];
    } else {
      this.type = ["1", "5", "2", "4"];
    }
    this.clientid = this.$store.state.clientid;
    this.token = this.$store.state.token;
    this.$store.dispatch("LOAD_VEHICLE_TYPE");
    this.overlay = true;
    this.$store.commit("CLEAR_CABINETS");
    this.$store.dispatch("LOAD_CABINETS");
    this.getUser();
    this.getAssetGroups();
    this.getHash();
    this.loadUserData();
    this.getTimezone();
    this.getCompany();
    this.getCompanyEmailAddress();
  },
  watch: {
    "editedItem.type"(newValue) {
      const val = parseInt(newValue, 10);
      if (val === 1 || val === 3) {
        this.editedItem.metadata.as_manager = true;
      }
    },
    "editedItem.metadata.is_special"(val) {
      if (val) {
        this.editedItem.metadata.is_special_state = false;
      }
    },
    "editedItem.metadata.is_special_state"(val) {
      if (val) {
        this.editedItem.metadata.is_special = false;
      }
    },
    groups(val) {
      if (isNull(val)) return;
      this.grpAssets = val.join();
    },
    vhcTypeId(value) {
      this.editedItem.metadata.vehicle_type = [];
      value.forEach((v) => {
        this.editedItem.metadata.vehicle_type.push({
          id: v,
          approve: 1,
        });
      });
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
    assetGroup(val) {
      if (isNull(val)) return;
      this.groupParam = val.map((v) => v.id);
    },
    upload_photo(value) {
      if (Array.isArray(value) ? value.length !== 0 : !!value) {
        this.uploadPhotoRequired = false;
      }
    },
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 2e3)
    },
    searchData(value) {
      this.doSearch();
    },
    selectedCompany(value) {
      this.selectedCompanyParam = value.clientid;
      this.doSearch();
    }
  },
  mounted() {
    if (this.rfidRequired) {
      const rfidType = { text: "RFID Type", value: "metadata.rfid_type", sortable: false };
      const rfidNumber = { text: "RFID Number", value: "metadata.key_cabinet_rfid", sortable: false };
      this.headers.splice(13, 0, rfidType);
      this.headers.splice(14, 0, rfidNumber);
    }
  },
  methods: {
    openBulkEditDialog() {
      this.bulkEditDialog = true;
      this.bulkEditUsers = [];
      this.bulkEditTimezone = null;
    },
    toggleCheckAll() {
      if (this.isAllChecked) {
        this.bulkEditUsers = [];
      } else {
        this.bulkEditUsers = this.userTimezoneOptions.map(u => `${u.id}`);
      }
    },
    bulkEditUsersTimezone() {
      if (!this.bulkEditTimezone) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error',
          text: 'Please select a timezone.',
        });
        return;
      }
      this.loadingBulkEdit = true;
      this.loader = this.loadingBulkEdit;
      const postData = {
        clientid: this.clientid,
        timezone: this.bulkEditTimezone,
        user_ids: this.bulkEditUsers,
      };
      this.$store.dispatch('API_CALL', {
        $method: 'bulk_edit_user_timezone',
        $postData: postData,
      })
        .then((response) => {
          this.loadingBulkEdit = false;
          this.loader = this.loadingBulkEdit;
          if (response.data.code === 200) {
            this.$swal({
              type: 'success',
              title: 'Success',
              icon: 'success',
              text: 'User timezones updated successfully.',
            });
            this.bulkEditDialog = false;
            this.loadUserData();
          } else {
            this.$swal({
              type: 'error',
              title: 'Error',
              icon: 'error',
              text: response.data.message || 'Failed to update user timezones.',
            });
          }
        })
        .catch(() => {
          this.loadingBulkEdit = false;
          this.loader = this.loadingBulkEdit;
          this.$swal({
            type: 'error',
            title: 'Error',
            icon: 'error',
            text: 'An error occurred while updating user timezones.',
          });
        });
    },
    handleClickSpecialState() {
      this.$nextTick(() => {
        if (this.editedItem.metadata.is_special_state) {
          this.editedItem.metadata.is_special = false;
        }
        this.$forceUpdate();
      });
    },
    getValueAsBoolean(value) {
      return value == 1 || value == '1' || value == 'true' || value == true ? 1 : 0;
    },
    setStatus(item) {
      if (!item) return
      let text = ""
      let licenseUser = get(item.metadata, "driver_license.expiry_date", "");
      if (!isEmpty(licenseUser)) {
        let now = moment().format("YYYY-MM-DD");
        const isValidLicense = moment(licenseUser).diff(now, "days");
        if (isValidLicense > 30) {
          text = "Valid"
        } else if (isValidLicense < 30 && isValidLicense > 0) {
          text = "Expired Soon"
        } else if (isValidLicense < 0) {
          text = "Expired"
        }
      }
      return text
    },
    setColor(item) {
      if (!item) return
      let text = ""
      let licenseUser = get(item.metadata, "driver_license.expiry_date", "");
      if (!isEmpty(licenseUser)) {
        let now = moment().format("YYYY-MM-DD");
        const isValidLicense = moment(licenseUser).diff(now, "days");
        if (isValidLicense > 30) {
          text = "success"
        } else if (isValidLicense < 30 && isValidLicense > 0) {
          text = "warning"
        } else if (isValidLicense < 0) {
          text = "error"
        }
      }
      return text
    },
    generateReport() {
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      this.$store.dispatch('API_CALL', {
        $method: 'get_report',
        $postData: {
          clientid: this.clientid,
          report_type: "user"
        },
      })
        .then((response) => {
          this.loadingUpdate = false;
          this.loader = this.loadingUpdate;
          if (response.data.code == 200) {
            this.responseReport = response.data.data.report;
            var fileURL = this.responseReport;
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            document.body.appendChild(fileLink);
            fileLink.click();
          }
        })
        .catch((error) => {
          this.loadingUpdate = false;
          this.loader = this.loadingUpdate;
          if (error.response && error.response.data && error.response.data.code == 200) {
            if (error.response.data.data && error.response.data.data.report) {
              this.responseReport = error.response.data.data.report;
              var fileURL = this.responseReport;
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              document.body.appendChild(fileLink);
              fileLink.click();
            }
          } else {
            // Actual error occurred
            this.$swal({
              type: 'error',
              title: 'Error',
              icon: 'error',
              text: error.response.data.data.message || error.response.data.message || error.message || 'An error occurred while generating report.',
            });
          }
        });
    },
    loadUserData() {
      this.getUserTotal();
      this.getData();
    },
    resetForm() {
      this.editedItem = {
        username: "",
        password: "",
        clientid: "",
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        type: "",
        timezone: {
          value: "AUS Eastern Standard Time"
        },
        metadata: {
          vehicle_type: [],
          rfid_type: null,
          key_cabinet_rfid: "",
          key_cabinet_rfid_bin: "",
          user_manage: [],
          as_manager: false,
          is_special: false,
          is_special_state: false,
          special_states: [],
          driver_license: {
            issuing_state: "",
            license_type: "",
            conditions: "",
            license_no: "",
            expiry_date: "",
          },
          upload_photo: "",
          use_sso: this.isSSO,
        },
      };
      if (this.isWollongong) {
        this.editedItem.metadata.driver_license.license_type = 'Vehicle / Car';
        this.editedItem.metadata.driver_license.conditions = 'All';
        this.editedItem.metadata.driver_license.issuing_state = 'NSW';
        this.editedItem.metadata.driver_license.license_no = '-';
        this.editedItem.metadata.driver_license.expiry_date = '2050-01-01';
        this.assetGroup = this.assetGroups.filter(g => g.name == 'Carpool');
      }
    },
    validatePhoto(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      if (files[0]['type'] === 'image/jpeg' || files[0]['type'] === 'image/jpg' || files[0]['type'] === 'image/png') {
        if (file['size'] < 200000) {
          reader.onloadend = (file) => {
            this.form.mellicode_front_url = reader.result;
          }
          reader.readAsDataURL(file);
        } else {
          this.$swal({
            type: 'error',
            title: 'Size limited.',
            text: 'size limit',
          })
        }
      } else {
        this.$swal({
          type: 'error',
          title: 'Type error.',
        })
      }
    },
    showPhotoEdit() {
      let getPhoto = get(this.editedItem, "metadata.photo", "");

      if (isEmpty(getPhoto)) {
        this.showDefaultPhoto = true;
      } else {
        this.showPhotoDialog = true;
        this.photoUrl = `${process.env.VUE_APP_API_URL}/${getPhoto}`;
      }
    },
    getUser() {
      this.$store.dispatch('API_CALL', {
        $method: 'get_all',
        $postData: {
          clientid: this.clientid,
        },
      })
        .then((response) => {
          this.userTimezoneOptions = get(response, 'data.data', []);
        });
    },
    isValidDate(dateString) {
      if (dateString == '' || dateString == '0000-00-00') return false;
      const date = new Date(dateString);
      return date instanceof Date && !isNaN(date);
    },
    editItem(item) {
      this.loadingAssetGroup = true;
      this.editedIndex = this.dataApi.indexOf(item);
      this.editedItem = cloneDeep(item);
      this.editedItem.metadata.use_sso = this.getValueAsBoolean(get(this.editedItem, 'metadata.use_sso', this.isSSO)) ? true : false;
      this.editedItem.metadata.rfid_type = get(this.editedItem, 'metadata.rfid_type', "");
      this.editedItem.metadata.key_cabinet_rfid = get(this.editedItem, 'metadata.key_cabinet_rfid', "");
      this.editedItem.metadata.key_cabinet_rfid_bin = get(this.editedItem, 'metadata.key_cabinet_rfid_bin', "");
      this.editedItem.metadata.user_manage = get(this.editedItem, 'metadata.user_manage', []);
      this.editedItem.metadata.as_manager = this.getValueAsBoolean(get(this.editedItem, 'metadata.as_manager', false)) ? true : false;
      if (this.editedItem.type == 1 || this.editedItem.type == 3) {
        if (!this.editedItem.metadata.hasOwnProperty('is_special')) {
          this.editedItem.metadata.is_special = true;
        }
      }
      this.editedItem.metadata.is_special = this.getValueAsBoolean(get(this.editedItem, 'metadata.is_special', false)) ? true : false;
      this.editedItem.metadata.is_special_state = this.getValueAsBoolean(get(this.editedItem, 'metadata.is_special_state', false)) ? true : false;
      this.editedItem.metadata.special_states = get(this.editedItem, 'metadata.special_states', []);
      this.editedItem.metadata.driver_license = get(this.editedItem, 'metadata.driver_license', {});
      this.editedItem.metadata.driver_license.issuing_state = get(this.editedItem, 'metadata.driver_license.issuing_state', "");
      this.editedItem.metadata.driver_license.license_type = get(this.editedItem, 'metadata.driver_license.license_type', "");
      this.editedItem.metadata.driver_license.conditions = get(this.editedItem, 'metadata.driver_license.conditions', "");
      this.editedItem.metadata.driver_license.license_no = get(this.editedItem, 'metadata.driver_license.license_no', "");
      this.editedItem.metadata.driver_license.expiry_date = get(this.editedItem, 'metadata.driver_license.expiry_date', "");
      if (!this.isValidDate(this.editedItem.metadata.driver_license.expiry_date)) this.editedItem.metadata.driver_license.expiry_date = '';
      this.editedItem.metadata.driver_license.upload_photo = get(this.editedItem, 'metadata.photo', "");
      this.token = this.$store.state.token;
      this.$store.dispatch('API_CALL', {
        $method: 'get_asset_groups_user',
        $postData: {
          user_id: item.id,
        },
      })
        .then((response2) => {
          const userGroups = get(response2, 'data.data', []);
          this.assetGroupsEdit = this.assetGroups.filter((grp) => {
            const found = userGroups.find(ug => ug.group_id === grp.id);
            return typeof found !== 'undefined';
          });
          this.loadingAssetGroup = false;


        });
      this.dialog = true;
    },
    typeText(item) {
      let text = null;
      if (item.type == 1) {
        text = "Admin";
      } else if (item.type == 2) {
        text = "User";
      } else if (item.type == 3) {
        text = "Super Admin";
      } else if (item.type == 4) {
        text = "HR Access";
      } else if (item.type == 5) {
        text = "Admin Assistant";
      }
      return text;
    },
    assetGroupText(item, asTitle = false) {
      return item.groups
    },
    typeUser(item) {
      let text = null;
      if (item == 1) {
        text = "Admin";
      } else if (item == 2) {
        text = "User";
      } else if (item == 3) {
        text = "Super Admin";
      } else if (item == 4) {
        text = "HR Access";
      } else if (item == 5) {
        text = "Admin Assistant";
      }
      return text;
    },
    deleteItem(item) {
      this.deldialog = true;
      this.editedIndex = this.dataApi.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          const user = this.dataApi.find(
            (d) => d.username == this.editedItem.username
          );
          this.updateUser(user.id);
        } else {
          const existUser = this.dataApi.find(
            (d) => d.username == this.editedItem.username
          );
          const existEmail = this.dataApi.find(
            (d) => d.email == this.editedItem.email
          );

          if (existUser) {
            this.isError = true;
          } else if (existEmail) {
            this.emailCheck = true;
          } else {
            if (this.$store.state.type == 1) {
              this.editedItem.clientid = this.$store.state.clientid;
            }
            this.createUser();
          }
        }
      }
    },
    closeModal() {
      this.$refs.form.resetValidation();
      this.resetForm();
      this.editedIndex = -1;
      this.dialog = false;
    },
    hex2bin(hex) {
      if (typeof hex != 'String') {
        try {
          hex = hex.toString();
        } catch (e) {
          hex = "";
        }
      }
      hex = hex.replace("0x", "").toLowerCase();
      var out = "";
      for (let c of hex) {
        switch (c) {
          case '0': out += "0000"; break;
          case '1': out += "0001"; break;
          case '2': out += "0010"; break;
          case '3': out += "0011"; break;
          case '4': out += "0100"; break;
          case '5': out += "0101"; break;
          case '6': out += "0110"; break;
          case '7': out += "0111"; break;
          case '8': out += "1000"; break;
          case '9': out += "1001"; break;
          case 'a': out += "1010"; break;
          case 'b': out += "1011"; break;
          case 'c': out += "1100"; break;
          case 'd': out += "1101"; break;
          case 'e': out += "1110"; break;
          case 'f': out += "1111"; break;
          default: return "";
        }
      }
      return out;
    },
    getBinaryRFID() {
      const key_cabinet_rfid = get(this.editedItem, 'metadata.key_cabinet_rfid', '');
      const rfid_type = get(this.editedItem, 'metadata.rfid_type', '');

      if (key_cabinet_rfid == "") return null;
      if (this.isNedland) return this.hex2bin(key_cabinet_rfid);

      let bin = null;

      switch (rfid_type) {
        case 'RFID Card':
          const rfid_card = key_cabinet_rfid.substr(-6);
          bin = `1${this.hex2bin(rfid_card)}0`;
          break;
        case 'RFID Key Ring':
          const rfid_key_ring = key_cabinet_rfid.substr(-6);
          bin = `0${this.hex2bin(rfid_key_ring)}0`;
          break;
        case 'RFID Sticker':
          let rfid_sticker = key_cabinet_rfid.substr(-6);
          rfid_sticker = new BigNumber(rfid_sticker, 16).minus(1).toString(16);
          bin = `0${this.hex2bin(rfid_sticker)}0`;
          break;
        default:
          break;
      }

      return bin;
    },
    createUser() {
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;

      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      this.editedItem.metadata.key_cabinet_rfid_bin = this.getBinaryRFID();
      if (this.editedItem.metadata.vehicle_type) delete this.editedItem.metadata.vehicle_type
      const userIds = this.userDatas.reduce((arr, value) => {
        arr.push(value.id);
        return arr;
      }, [])
      if (this.editedItem.metadata.as_manager == true || this.editedItem.metadata.as_manager == 'true') {
        this.editedItem.metadata.user_manage = userIds;
      }
      let getTimezone = get(this.editedItem, "timezone", "");
      let checkTimezone = typeof getTimezone === "string" ? getTimezone : get(this.editedItem, "timezone.value", "");

      this.editedItem.timezone = checkTimezone;

      if (this.editedItem.metadata.use_sso) {
        this.editedItem.username = this.editedItem.email;
        this.editedItem.password = 'user123';
      }

      if (this.editedItem.metadata.driver_license.upload_photo) {

        const formData = new FormData();

        formData.append('token', this.token)
        formData.append('photo', this.editedItem.metadata.driver_license.upload_photo)
        formData.append('data', JSON.stringify(this.editedItem))

        const showCreateError = (message) => {
          this.loadingUpdate = false;
          this.loader = this.loadingUpdate;
          this.$swal({ icon: "error", title: message });
        };

        return api.post(`${process.env.VUE_APP_API_URL}/create_user`, formData).then((response) => {
          if (response.data.code == 200) {
            const specialGroup = this.assetGroups.find(g => g.name == 'Special Group of ' + this.clientid);
            let groupParam = this.groupParam;

            if (specialGroup) {
              const isSpecialSelected = this.groupParam.includes(specialGroup.id);
              if (isSpecialSelected) {
                const isSpecial = this.getValueAsBoolean(get(this.editedItem, 'metadata.is_special', false));
                if (!isSpecial) {
                  groupParam = this.groupParam.filter(g => g != specialGroup.id);
                }
              }
            }

            this.$store.dispatch('API_CALL', {
              $method: 'update_asset_group_user',
              user_id: response.data.data.user_id,
              group_id: groupParam.join(),
            })
              .then(() => {
                this.loadingUpdate = false;
                this.loader = this.loadingUpdate;

                this.$swal({
                  icon: "success",
                  title: response.data.data.message,

                }).then((res) => {
                  if (res.isConfirmed) {
                    this.closeModal();
                    this.resetForm();
                    this.loadUserData();
                  }
                });
              });
          } else {
            showCreateError(response.data.data.message);
          }
        })
        .catch((error) => {
          showCreateError(error.message);
        });
      } else {
        this.$store.dispatch('API_CALL', {
          $method: 'create_user',
          data: this.editedItem,
          clientid: this.clientid,
        })
          .then((response) => {
            if (response.data.code == 200) {
              this.$store.dispatch('API_CALL', {
                $method: 'update_asset_group_user',
                user_id: response.data.data.user_id,
                group_id: this.groupParam.join(),
              })
                .then(() => {
                  this.loadingUpdate = false;
                  this.loader = this.loadingUpdate;

                  this.$swal({
                    icon: "success",
                    title: response.data.data.message,
                  }).then((res) => {
                    if (res.isConfirmed) {
                      this.closeModal();
                      this.resetForm();
                      this.loadUserData();
                    }
                  });
                });
            } else {
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
              this.$swal({
                icon: "error",
                title: response.data.data.message,
              })
            }
          });
      }
    },
    updateUser(id) {
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      this.clientid = this.$store.state.clientid;
      this.token = this.$store.state.token;
      this.editedItem.metadata.key_cabinet_rfid_bin = this.getBinaryRFID();

      const userIds = this.userDatas.reduce((arr, value) => {
        arr.push(value.id);
        return arr;
      }, [])

      if (this.editedItem.metadata.as_manager == true || this.editedItem.metadata.as_manager == 'true') {
        this.editedItem.metadata.user_manage = userIds;
      }

      let getTimezone = get(this.editedItem, "timezone", "");
      let checkTimezone = typeof getTimezone === "string" ? getTimezone : get(this.editedItem, "timezone.value", "");

      this.editedItem.timezone = checkTimezone;

      const formData = new FormData();
      if (this.changePhoto) {
        formData.append('photo', this.changePhoto)
      } else {
        formData.append('photo', this.editedItem.metadata.driver_license.upload_photo)
      }
      formData.append('token', this.token)
      formData.append('id', this.editedItem.id)
      formData.append('data', JSON.stringify(this.editedItem))

      const showUpdateError = (message) => {
        this.loadingUpdate = false;
        this.loader = this.loadingUpdate;
        this.$swal({ icon: "error", title: message });
      };

      return api.post(`${process.env.VUE_APP_API_URL}/update_user`, formData).then((response) => {
        if (response.data.code == 200) {
          this.$store.dispatch('API_CALL', {
            $method: 'update_asset_group_user',
            user_id: this.editedItem.id,
            group_id: this.assetGroupsEdit.map(g => g.id).join(','),
          })
            .then(() => {
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
              this.dialog = false;

              if (response.data.data.hasOwnProperty('driver_license_uploaded')) {
                let driverLicense = response.data.data.driver_license_uploaded;
                this.$swal({
                  icon: "success",
                  title: `Success update user, but failed to upload the license photo, because ${driverLicense.message.toLowerCase()}`,
                }).then((res) => {
                  if (res.isConfirmed) {
                    this.closeModal();
                    location.reload();
                  }
                });
              } else {
                this.$swal({
                  icon: "success",
                  title: "Success update user",
                }).then((res) => {
                  if (res.isConfirmed) {
                    this.closeModal();
                    this.resetForm();
                    this.loadUserData();
                  }
                });
              }
              this.changePhoto = "";
              Object.assign(this.dataApi[this.editedIndex], this.editedItem);
            });
        } else {
          showUpdateError(response.data.data.message);
        }
      })
      .catch((error) => {
        showUpdateError(error.message);
      });
    },
    deleteUser() {
      this.clientid = this.$store.state.clientid;
      this.token = this.$store.state.token;
      const user = this.dataApi.find(
        (d) => d.username == this.editedItem.username
      );
      const userIndex = this.dataApi.findIndex(
        (d) => d.username == this.editedItem.username
      );
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;

      this.$store.dispatch('API_CALL', {
        $method: 'delete_user',
        clientid: this.clientid,
        id: user.id,
      })
        .then((response) => {
          this.deldialog = false;
          this.loadingUpdate = false;
          this.loader = this.loadingUpdate;

          this.$swal({
            icon: "success",
            title: response.data.data.message,
          });

          this.getUserTotal();
          this.getData();
          this.editedIndex = -1;
          this.editedItem = Object.assign({}, this.defaultItem);
          Promise.all([
            this.getUserTotal(),
            this.getData(),
          ]).then(() => {
            if (this.userTotal > 0 && this.dataApi.length === 0) {
              this.paginationOptions.page = 1
              this.getUserTotal();
              this.getData();
            }
          })

          this.$store.dispatch('API_CALL', {
            $method: 'get_book_by_user_id',
            user_id: user.id,
          })
            .then((response2) => {
              if (response2 !== null) {
                this.getBookedDataById = response2.data.data;
                this.book_id = this.getBookedDataById[0].book_id;
                this.getBookedDataById.map((data) => {
                  this.$store.dispatch('API_CALL', {
                    $method: 'delete_book',
                    book_id: data.book_id,
                  })
                });
              }
            });
        });
    },
    getUserTotal() {
      this.clientid = this.$store.state.clientid;
      if (this.$store.state.type === "3") {
        const apiParams = {
          $method: "get_user_total",
          query: this.searchData,
        };

        if (!isEmpty(this.selectedCompany) && !isUndefined(this.selectedCompany)) {
          this.clientid = this.selectedCompanyParam;
          apiParams.clientid = this.clientid;
        }

        return this.$store.dispatch("API_CALL", apiParams)
          .then((response) => {
            this.userTotal = parseInt(response.data.data.total);
          });
      } else {
        return this.$store.dispatch('API_CALL', {
          $method: 'get_user_total',
          clientid: this.clientid,
          query: this.searchData
        })
          .then((response) => {
            this.userTotal = parseInt(response.data.data.total);
          });
      }
    },
    getData() {
      if (this.loadingUser) return
      this.loadingUser = true;
      this.clientid = this.$store.state.clientid;

      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by = sortBy.length ? sortBy[0] : 'username';
      const sort_dir = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'asc';
      const offset = (page - 1) * itemsPerPage;

      if (this.$store.state.type === "3") {
        const apiParams = {
          $method: "get_all",
          query: this.searchData,
          limit: itemsPerPage,
          offset,
          sort_by,
          sort_dir,
        };

        if (!isEmpty(this.selectedCompany) && !isUndefined(this.selectedCompany)) {
          this.clientid = this.selectedCompanyParam;
          apiParams.clientid = this.clientid;
        }

        return this.$store.dispatch("API_CALL", apiParams)
          .then((response) => {
            this.loadingUser = false;
            this.dataApi = response.data.data.filter(
              (data) => data.status == 1 || data.status == 2
            );
          });
      } else {
        return this.$store.dispatch('API_CALL', {
          $method: 'get_all',
          clientid: this.clientid,
          limit: itemsPerPage,
          offset,
          sort_by,
          sort_dir,
          query: this.searchData
        })
          .then((response) => {
            this.loadingUser = false;
            const responseData = get(response, 'data.data', []);
            this.dataApi = responseData.filter(
              (data) => data.status == 1 || data.status == 2
            );
          });
      }
    },
    getTimezone() {
      this.$store.dispatch('API_CALL', {
        $method: 'get_timezone'
      })
        .then((response) => {
          this.dataTimezone = response.data.data;
        });
    },
    getCompany() {
      this.$store.dispatch('API_CALL', {
        $method: 'get_all_company',
        query: this.searchData
      })
        .then((response) => {
          if (this.$store.state.type == 3) {
            this.dataCompany = response.data.data.filter(
              (companies) => companies.active == 1
            );
          }
          this.editedItem.metadata.use_sso = this.isSSO;
          this.defaultItem.metadata.use_sso = this.isSSO;
        });
    },
    sendInvitationEmail() {
      const emailValid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.inviteEmail);
      if (!emailValid) {
        this.$swal({
          icon: 'error',
          title: 'Invalid email address',
        });
        return;
      }
      this.loadingInvite = true;
      this.$store.dispatch('API_CALL', {
        $method: 'send_invitation_email',
        $postData: {
          email: this.inviteEmail,
          registration_link: this.shareLink,
          clientid: this.clientid,
        },
      })
        .then((response) => {
          this.loadingInvite = false;
          if (response.data.code === 200) {
            this.$swal({
              icon: 'success',
              title: 'Invitation email sent successfully!',
            });
            this.inviteEmail = '';
            this.dialog2 = false;
          } else {
            this.$swal({
              icon: 'error',
              title: response.data.data.message || 'Failed to send invitation email.',
            });
          }
        })
        .catch(() => {
          this.loadingInvite = false;
          this.$swal({
            icon: 'error',
            title: 'An error occurred while sending invitation email.',
          });
        });
    },
    copyLink() {
      let textToCopy = this.$refs.textToCopy.$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");
      this.dialog3 = true;
      this.dialog2 = false;
    },
    getHash() {
      this.$store.dispatch('API_CALL', {
        $method: 'get_hash_invite_link',
        clientid: this.clientid,
      })
        .then((response) => {
          if (response !== null) {
            const hash = response.data.data.hash;
            this.shareLink = `${process.env.VUE_APP_CARPOOLING_URL
              }/#/register/${hash}`;

            this.getCompanyEmailAddress(hash);
          }
        });
    },
    getCompanyEmailAddress(hash) {
      this.$store.dispatch('API_CALL', {
        $method: 'get_company_email_address',
        $postData: {
          hash: hash,
        },
      })
        .then((response) => {
          this.emailAddress = response.data.data.company_email_address;
        });
    },
    showPhoto(item) {
      this.photoUrl = `${process.env.VUE_APP_API_URL}/${item.metadata.photo
        }`;
      this.showPhotoDialog = true;
    },
    setVhcTypes(item) {
      this.vhcTypes = [];
      if (
        isUndefined(item.metadata.vehicle_type) ||
        isNull(item.metadata.vehicle_type)
      ) {
        this.getVhcTypes();
      } else {
        let parseData = JSON.parse(item.metadata.vehicle_type);
        let dataTypes = this.$store.getters["getVehicleType"];
        parseData.forEach((v) => {
          let getVehicles = dataTypes.find(
            (type) => type.id == v.id
          );
          this.vhcTypes.push({ id: getVehicles.id, name: getVehicles.name });
        });
      }
    },
    getVhcTypes() {
      return this.$store.dispatch('API_CALL', {
        $method: 'get_vehicle_types',
        $postData: {
          clientid: this.clientid,
        },
      })
        .then((response) => {
          this.vhcTypes = response.data.data;
        });
    },
    getAssetGroups() {
      this.token = this.$store.state.token;
      this.$store.dispatch('API_CALL', {
        $method: 'get_asset_groups',
        $postData: {
          clientid: this.$store.state.user.user.clientid,
          show_detail: 0
        },
      })
        .then((response) => {
          this.assetGroups = response.data.data;
          if (this.isWollongong) {
            this.editedItem.metadata.driver_license.license_type = 'Vehicle / Car';
            this.editedItem.metadata.driver_license.conditions = 'All';
            this.editedItem.metadata.driver_license.issuing_state = 'NSW';
            this.editedItem.metadata.driver_license.license_no = '-';
            this.editedItem.metadata.driver_license.expiry_date = '2050-01-01';
            this.assetGroup = this.assetGroups.filter(g => g.name == 'Carpool');
          }
        });
    },
    setInputTimezone($event) {
      this.editedItem.timezone = $event;
    },
    updatePaging(options) {
      this.getUserTotal();
      this.paginationOptions = options;
      this.getData();
    },
    doSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.paginationOptions.page = 1;
        this.paginationOptions.sortBy = [];
        this.paginationOptions.sortDesc = [];
        this.getUserTotal();
        this.getData();
      }, 1e3)
    },
    setHumanDate(item) {
      let getDate = get(item, 'metadata.driver_license.expiry_date', "");
      let humanDate = ""
      if (!isEmpty(getDate)) {
        humanDate = moment(getDate).format("D MMM YYYY");
      }
      return humanDate;
    }
  },
};
</script>

<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:nth-child(7) {
  min-width: 300px !important;
}
</style>